import { authResource, AuthResource } from '@witkac/kartamiejska-resources';
import { Profile, Login, SessionStorage } from '@witkac/kartamiejska-shared';
import jwt from 'jsonwebtoken';

import { AbstractModule } from './abstract.module';

/**
 * Moduł autentykacji
 *
 * @class AuthModule
 * @extends {AbstractModule<AuthResource>}
 */
class AuthModule extends AbstractModule<AuthResource> {
  public state = {
    profile: undefined,
    permissions: {}
  };

  public mutations = {
    /**
     * Zapisuje dane profilu do store
     *
     * @param localState state
     * @param profile profil użytkownika
     */
    save(localState: any, profile: Profile): void {
      localState.profile = profile;
    },
    /**
     * Zapisuje uprawnienia do  store
     *
     * @param {*} localState
     * @param {object} permission
     */
    savePermissions(localState: any, permissions: any) {
      localState.permissions = { ...localState.permissions, ...permissions };
    }
  };

  public actions = {
    /**
     * Logowanie
     *
     * @param context context
     * @param data dane logowania
     */
    login: async (context: any, data: Login): Promise<{ profile: Profile; hasAllConsents: boolean }> => {
      const { token, profile, hasAllConsents } = await this.resource.login(data.login, data.password);
      if (profile.partner) {
        sessionStorage.setItem(SessionStorage.PARTNER_ID, '' + profile.partner.id);
      }
      sessionStorage.setItem(SessionStorage.TOKEN, token);
      sessionStorage.setItem(SessionStorage.PROFILE_ID, '' + profile.id);
      sessionStorage.setItem(SessionStorage.USER_ID, '' + profile.userId);
      sessionStorage.setItem(SessionStorage.PROFILE_TYPE, '' + profile.type);
      context.commit('save', profile);
      context.dispatch('updateTokenOnExpire', token);
      return { profile, hasAllConsents };
    },
    /**
     * Odświeża token
     *
     * @type {async}
     * @memberof AuthModule
     */
    refreshToken: (context: any): Promise<void> => {
      return this.resource.refreshToken().then(token => {
        sessionStorage.setItem(SessionStorage.TOKEN, token);
        context.dispatch('updateTokenOnExpire', token);
      });
    },
    /**
     * Odświeża token, gdy kończy się jego ważność
     */
    updateTokenOnExpire: (context: any, token: string): void => {
      const tokenPayload: any = jwt.decode(token);
      const tokenExpInMs = tokenPayload.exp * 1000;
      const reservedTime = 1000 * 60 * 6;
      const timeToExpiration = tokenExpInMs - new Date().getTime() - reservedTime;
      setTimeout(() => context.dispatch('refreshToken'), timeToExpiration);
    },
    /**
     * Sprawdzanie uprawnień
     *
     * @param context context
     * @param permission dane
     *
     */
    checkPermissions: async (context: any, permissionsNames: []): Promise<void> => {
      const valid = await this.resource.checkPermission(permissionsNames);
      const permissions: any = {};
      for (let i = 0; i < permissionsNames.length; i++) {
        permissions[permissionsNames[i]] = valid[i];
      }
      context.commit('savePermissions', permissions);
    }
  };
}

export default new AuthModule(authResource);
